import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MaskedLines, Reveal } from "../components/Motion";
import { ProjectCard } from "../components/ProjectCard";
import { PROJECTS } from "../lib/data";

const filters = [
  { key: "all", label: "All" },
  { key: "noida", label: "Noida / UP" },
  { key: "goa", label: "Goa" },
];

export default function Projects() {
  const [active, setActive] = useState("all");
  const list = active === "all" ? PROJECTS : PROJECTS.filter((p) => p.cityKey === active);

  return (
    <div data-testid="projects-page" className="pt-32 md:pt-44">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="overline text-[#C19A6B] mb-6">Portfolio</p>
        <h1 className="font-serif-lux text-[#1A1A1A] text-[13vw] md:text-[8vw] leading-[0.9] tracking-tight">
          <MaskedLines lines={["Projects worth", "a site visit."]} />
        </h1>

        {/* Filter */}
        <div data-testid="project-filters" className="flex flex-wrap gap-3 mt-14 border-t border-[#E5DFD3] pt-8">
          {filters.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setActive(f.key)}
              className={`px-6 py-3 overline border transition-colors duration-300 ${
                active === f.key
                  ? "bg-[#1A1A1A] text-[#FDFBF7] border-[#1A1A1A]"
                  : "bg-transparent text-[#5C5C5C] border-[#E5DFD3] hover:border-[#1A1A1A] hover:text-[#1A1A1A]"
              }`}
            >
              {f.label}
            </button>
          ))}
          <span className="ml-auto self-center font-sans-lux text-sm text-[#5C5C5C]">
            {list.length} {list.length === 1 ? "project" : "projects"}
          </span>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <motion.div layout className="grid md:grid-cols-2 gap-x-8 gap-y-16">
          <AnimatePresence mode="popLayout">
            {list.map((p, i) => (
              <motion.div
                key={p.slug}
                layout
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
              >
                <ProjectCard project={p} index={i} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </section>
    </div>
  );
}
